import React, {
  ButtonHTMLAttributes,
  forwardRef,
  PropsWithChildren,
} from "react";
import { _SpanButtonRoot } from "./SpanButton.styled";

const SpanButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<ButtonHTMLAttributes<any>, "type">>
>((props, ref) => {
  return <_SpanButtonRoot ref={ref} {...props} />;
});
export default SpanButton;
